import React, { PureComponent } from "react";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import {showhtml} from  'utils/methods'
// require("./index.css");
import './index.scss'
export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo:{},
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    const {
      location: { state }
    } = this.props;
    this.getDetail(state)
  };
  getDetail =(state)=>{
    Http.get(Request.getArticleDetail(), {id:state.id}, obj => {
        // return
        console.log('objobjobjobjobbjo',obj);
        
        if(obj.code == 200){
            this.setState({dataInfo:obj.data.article,beforeArticle:obj.data.beforeArticle,nextArticle:obj.data.nextArticle})
        }
      });
  }
  
  download(pre) {
    let id = pre.id;
    window.location = `http://yhbest.imwork.net:30080/blade-portal/articleUtils/downloadSingFile?id=${id}`;
  }

  goDetail(id, e) {
    e.preventDefault();
    this.props.history.replace("/entrance/PolicyDetails?" + id);
    window.location.reload()
  }

  render() {
    const { dataInfo,beforeArticle, nextArticle} = this.state;
    
    return (
      <div id='root'>
        <div className='infoBox'>

          <div className='detailBox'>
              <div className='topBox'>
                  <h2>{dataInfo.title}</h2>
                  <div className='detailInfo'>
                    <div className='soureBox'>
                        来源：{dataInfo.fromurl}
                    </div>
                    <div className='author'>作者：{dataInfo.author}</div>
                    <div className='detailTime'>
                        时间：{dataInfo.createTime}
                    </div>
                  </div>
              </div>
              <div className='detailContent'>
                  {/* <div v-html={dataInfo.content}></div> */}
                  
                  <div dangerouslySetInnerHTML={{ __html:dataInfo.content}} />
              </div>
              <div className='nextBox' style={{display:'flex' ,justifyContent:'space-between'}} >
                <div>上一篇：<span style={{cursor:'pointer',}} onClick={()=>{this.getDetail(beforeArticle)}}>{beforeArticle?.title}</span></div>
                <div>下一篇：<span style={{cursor:'pointer'}} onClick={()=>{this.getDetail(nextArticle)}}>{nextArticle?.title}</span></div>
              </div>
          </div>
        </div>
        
      </div>
    );
  }
}
